module.exports = __webpack_public_path__ + "img/1.3.TP.6559dfae.png";